import React from "react";

import { IgTooltip } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { AdvancedTestIconFilled } from "../../../images/Icons/ContentTest/AdvancedTest/AdvancedTestIconFilled";
import { OnsiteEditsTestIconFilled } from "../../../images/Icons/ContentTest/OnsiteEditTest/OnsiteEditsTestIconFilled";
import { OnsiteInjectionsIconFilled } from "../../../images/Icons/ContentTest/OnsiteEditTest/OnsiteInjectionsIconFilled";
import { SplitUrlTestIconFilled } from "../../../images/Icons/ContentTest/SplitUrlTest/SplitUrlTestIconFilled";
import { TemplateTestIconFilled } from "../../../images/Icons/ContentTest/TemplateTest/TemplateTestIconFilled";
import { ThemeTestIconFilled } from "../../../images/Icons/ContentTest/ThemeTest/ThemeTestIconFilled";
import { OfferTestIcon } from "../../../images/Icons/Offer/OfferTestIcon";
import { PriceTestIconFilled } from "../../../images/Icons/PriceTest/PriceTestIconFilled";
import { ShippingTestIcon } from "../../../images/Icons/ShippingTest/ShippingTestIcon";
import theme from "../../../theme";

interface TestTypeIconProps {
  testFlowType: string;
  fontSize?: string;
  iconMarginTop?: string;
  isPersonalization?: boolean;
}
export const TestTypeIcon = ({
  testFlowType,
  fontSize,
  iconMarginTop,
  isPersonalization,
}: TestTypeIconProps) => {
  let testTypeObject: { title: string; icon: JSX.Element };
  switch (testFlowType) {
    case "content/advanced":
      testTypeObject = {
        title: "Advanced Content Test",
        icon: <AdvancedTestIconFilled sx={{ fontSize: fontSize ?? "20px" }} />,
      };
      break;
    case "content/onsiteEdits":
      testTypeObject = {
        title: isPersonalization
          ? "Content Edit Modification"
          : "Onsite Edit Test",
        icon: (
          <OnsiteEditsTestIconFilled sx={{ fontSize: fontSize ?? "20px" }} />
        ),
      };
      break;
    case "content/url":
      testTypeObject = {
        title: `URL Redirect ${isPersonalization ? "Modification" : "Test"}`,
        icon: <SplitUrlTestIconFilled sx={{ fontSize: fontSize ?? "20px" }} />,
      };
      break;
    case "content/theme":
      testTypeObject = {
        title: `Theme ${isPersonalization ? "Modification" : "Test"}`,
        icon: <ThemeTestIconFilled sx={{ fontSize: fontSize ?? "20px" }} />,
      };
      break;
    case "content/template":
      testTypeObject = {
        title: `Template ${isPersonalization ? "Modification" : "Test"}`,
        icon: <TemplateTestIconFilled sx={{ fontSize: fontSize ?? "20px" }} />,
      };
      break;
    case "pricing":
      testTypeObject = {
        title: `Price ${isPersonalization ? "Modification" : "Test"}`,
        icon: <PriceTestIconFilled sx={{ fontSize: fontSize ?? "20px" }} />,
      };
      break;
    case "personalization/offer":
      testTypeObject = {
        title: `Offer ${isPersonalization ? "Modification" : "Test"}`,
        icon: <OfferTestIcon sx={{ fontSize: fontSize ?? "20px" }} />,
      };
      break;
    case "shipping":
      testTypeObject = {
        title: "Shipping Test",
        icon: <ShippingTestIcon sx={{ fontSize: fontSize ?? "20px" }} />,
      };
      break;
    case "content/onsiteInjections":
      testTypeObject = {
        title: "Styles & Javascript",
        icon: (
          <OnsiteInjectionsIconFilled
            fill={theme.palette.primary.main}
            sx={{ fontSize: fontSize ?? "20px" }}
          />
        ),
      };
      break;
    default:
      testTypeObject = {
        title: "Advanced Test",
        icon: <AdvancedTestIconFilled sx={{ fontSize: fontSize ?? "20px" }} />,
      };
      break;
  }
  if (!testTypeObject.icon) return null;

  return (
    <IgTooltip title={testTypeObject.title}>
      <Grid sx={{ marginTop: iconMarginTop ?? "4px" }} item>
        {testTypeObject.icon}
      </Grid>
    </IgTooltip>
  );
};
